export function isEditablePasteTarget(target: EventTarget | null): boolean {
    if (!(target instanceof HTMLElement)) {
        return false;
    }

    return (
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        Boolean(target.isContentEditable) ||
        target.contentEditable === 'true'
    );
}

export function getPasteShortcut(platform: string = navigator.platform): 'Cmd+V' | 'Ctrl+V' {
    return /Mac|iPhone|iPad|iPod/.test(platform) ? 'Cmd+V' : 'Ctrl+V';
}

export function getFilesFromClipboardData(clipboardData: DataTransfer): File[] {
    const files = Array.from(clipboardData.files);

    if (files.length > 0) {
        return files;
    }

    return Array.from(clipboardData.items)
        .filter((item) => item.kind === 'file')
        .map((item) => item.getAsFile())
        .filter((file): file is File => Boolean(file));
}
